import React, { useEffect, useState, useCallback } from 'react';
import '../App.css';
import Modal from "./modals_transparent.tsx"
import DataService from '../helpers/DataService.ts'
import { request, AddressPurpose, RpcErrorCode, MessageSigningProtocols } from 'sats-connect'
import { loginSuccess, setToken, logoutUser } from "../store/actions"
import { useDispatch } from 'react-redux';
import { loadState } from '../store/localStorage.js';

// parche simple si la lib intenta usar crypto.createHash


function Main() {
    const [showModal, setShowModal] = useState(false)
    const [showModalSuccess, setShowModalSuccess] = useState(false)
    const [valueMail, setValueMail] = useState('')
    const [paymentAddressItem, setpaymentAddressItem] = useState<any>(undefined)
    const [paymentAddressItemDisplay, setpaymentAddressItemDisplay] = useState<any>(undefined)
    const [inputError, setInputError] = useState(false)
    const [authNonce, setauthNonce] = useState<any>(undefined)
    const [balance, setBalance] = useState(0)
    const [withdrawQuote, setwithdrawQuote] = useState<any>(undefined)
    const [withdrawQuoteTotal, setwithdrawQuoteTotal] = useState(0)
    const [balance_username, set_balance_username] = useState('')
    const [card_status, setCardStatus] = useState('connect')
    const card_status_connect = 'connect'
    const card_status_sign = 'sign'
    const card_status_mail = 'mail'
    const card_status_balance = 'balance'
    const dispatch = useDispatch();
    const client_id = 'de01d4ad-c24a-46fb-a5e8-755f3b7b7ab5'
    const min_balance_to_w = 10000

    const isValidEmail = (email: string): boolean => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const logout = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    }

    const getBalance = useCallback(() => {
        DataService.get_wallet_user_balance().then(response => {
            if (response && response.data) {
                setBalance(response.data.balance)
            }
        })
            .catch(err => {
                logout()
            })

    }, [])

    const getWallerUser = useCallback(() => {
        DataService.get_wallet_user().then(response => {
            if (response && response.data) {
                set_balance_username(response.data.username)
            }

        })

    }, [])

    useEffect(() => {
        const Auth = loadState()?.Auth;
        if (Auth && Auth.token && Auth.profile && Auth.profile.address) {
            const _paymentAddressItem = Auth.profile.address
            setpaymentAddressItem(_paymentAddressItem)
            setpaymentAddressItemDisplay(`${_paymentAddressItem?.address.substring(0, 5)}...${_paymentAddressItem?.address.substring(_paymentAddressItem?.address.length - 5, _paymentAddressItem?.address.length)}`)
            getBalance()
            getWallerUser()
            setCardStatus(card_status_balance)
        } else {
            setCardStatus(card_status_connect)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    function formatNumberWithCommas(amount: number | string): string {
        const number = typeof amount === "number" ? amount : parseFloat(amount);
        if (isNaN(number)) return "";

        return number.toLocaleString("en-US");
    }
    const connectWallet = async () => {
        try {
            const response = await request('wallet_connect', null);
            if (response.status === 'success') {
                const paymentAddressItem = response.result.addresses.find(
                    (address) => address.purpose === AddressPurpose.Payment
                );
                setpaymentAddressItem(paymentAddressItem)
                setpaymentAddressItemDisplay(`${paymentAddressItem?.address.substring(0, 5)}...${paymentAddressItem?.address.substring(paymentAddressItem?.address.length - 5, paymentAddressItem?.address.length)}`)
                if (paymentAddressItem && paymentAddressItem.address) {
                    DataService.get_login_auth_nonce(paymentAddressItem.address, client_id).then(response => {
                        if (response && response.data) {
                            setauthNonce(response.data)
                            signMail('', response.data.nonce, paymentAddressItem)
                        }
                    }).catch(error => {
                    })
                }
            } else {
                if (response.error.code === RpcErrorCode.USER_REJECTION) {
                    // handle user cancellation error
                } else {
                    // handle error
                }
            }
        } catch (err: any) {
            alert(err.error.message);
        }
    }

    const handleInputMailChange = (e: React.ChangeEvent<HTMLInputElement>, setValue: any) => {
        const inputValue = e.target.value;
        if (!inputValue) {
            setValue('')
            setInputError(false)
        } else {
            if (isValidEmail(inputValue)) {
                setInputError(false)
            } else {
                setInputError(true)
            }
            setValue(inputValue);
        }
    }

    const submit = async () => {
        if (inputError || !valueMail || !authNonce) {
            return
        }
        signMail(valueMail, authNonce.nonce, paymentAddressItem)

    }
    const signMail = async (_valueMail: string, _nonce: string, _paymentAddressItem: any) => {
        if (!_nonce || !_paymentAddressItem) {
            alert('missing values')
            return
        }

        const params = { message: _nonce, address: _paymentAddressItem.address, protocol: MessageSigningProtocols.ECDSA }

        const response = await request('signMessage', params)
        if (response && response.status === 'success') {
            const body = {
                signature: response.result.signature,
                nonce: _nonce,
                address: _paymentAddressItem.address,
                public_key: _paymentAddressItem.publicKey,
                email: _valueMail
            }
            DataService.post_login_auth_sign(_paymentAddressItem.address, client_id, body).then(response => {
                if (response && response.data) {

                    const user = { token: response.data.token, address: _paymentAddressItem }
                    dispatch(loginSuccess(user))
                    dispatch(setToken(response.data.token))
                    getBalance()
                    getWallerUser()
                    setCardStatus(card_status_balance)

                }
            })
        } else {
            alert('error')
        }
    }

    useEffect(() => {

        if (card_status !== card_status_balance) return;
        const token = loadState()?.Auth?.token
        if (!token) return;

        // Llamar inmediatamente
        getBalance();

        const interval = setInterval(() => {
            if (!token) return;
            getBalance();
        }, 20000); // 10 segundos

        return () => clearInterval(interval);
    }, [card_status, paymentAddressItem, getBalance]); // vuelve a ejecutar si card_status cambia

    const withdraw = () => {
        const blc = parseFloat(balance + '')
        if (blc < min_balance_to_w) {
            return;
        }
        DataService.post_wallet_user_withdraw_quote(paymentAddressItem.address).then(response => {
            if (response && response.data) {
                setwithdrawQuote(response.data)
                setwithdrawQuoteTotal(parseFloat(response.data.fee + '') + parseFloat(response.data.quantity + ''))
                setShowModal(true)

            }
        })
            .catch(err => {
                dispatch(logoutUser())
            })
    }
    const doWithdraw = () => {
        DataService.post_wallet_user_withdraw(paymentAddressItem.address).then(response => {
            if (response && response.data) {
                setShowModal(false)
                setShowModalSuccess(true)
                getBalance()

            }
        })
            .catch(err => {
                dispatch(logoutUser())
            })
    }
    const modalStyles = {
        overlay: {
            backgroundColor: "#0a0a0a",
        },
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '86%',
            maxWidth: '1120px',
        }
    }
    const __renderPOView = (params = null) => (
        <Modal
            title={``}
            isOpen={showModal}
            onRequestClose={() => {
                setShowModal(false);
            }}
            body={modalBody}
            footer={<></>}
            disableClose={true}
            styles={modalStyles}
            onAfterOpen={() => {

            }} contentLabel={undefined} />
    )
    const __renderPOViewSuccess = (params = null) => (
        <Modal
            title={``}
            isOpen={showModalSuccess}
            onRequestClose={() => {
                setShowModalSuccess(false);
            }}
            body={modalBodySuccess}
            footer={<></>}
            disableClose={true}
            styles={modalStyles}
            onAfterOpen={() => {

            }} contentLabel={undefined} />
    )



    const modalBody = <section>
        <div>

            <div className='wallet-modal'>
                <div className='wallet-modal-container'>
                    <div className='wallet-modal-close-icon' onClick={() => setShowModal(false)}>x</div>
                    <h2 className='wallet-modal-title'>You're Withdrawing Bitcoin</h2>
                    {!!withdrawQuote && (
                        <div style={{ display: 'flex', flexFlow: 'column' }}>
                            <span className='wallet-modal-title-row'>Full Balance: <b>{formatNumberWithCommas(withdrawQuoteTotal)} sats</b></span>
                            <span className='wallet-modal-title-row'>Transaction Fee: <b>{formatNumberWithCommas(withdrawQuote.fee)} sats</b> </span>
                            <br />
                            <span className='wallet-modal-title-row'>You Will Receive: <b>{formatNumberWithCommas(withdrawQuote.quantity)} sats</b> </span>
                            <br />
                        </div>

                    )}

                    <span>Destination</span>
                    <span>{paymentAddressItem && paymentAddressItem.address}</span>
                    <button type='button' className='btn close' onClick={doWithdraw}>Confirm</button>
                    <button type='button' className='btn cancel' onClick={() => setShowModal(false)}>Cancel</button>
                </div>
            </div>
        </div>
    </section>
    const modalBodySuccess = <section>
        <div>
            <div className='wallet-modal'>
                <div className='wallet-modal-container'>
                    <div className='wallet-modal-close-icon' onClick={() => setShowModalSuccess(false)}>x</div>
                    <h2 className='wallet-modal-title'>Transaction Executed</h2>
                    <span>
                        You'll get your funds in the <br />
                        connected Xverse wallet in just a<br />
                        few minutes.
                    </span>
                    <button className='btn cancel' onClick={() => setShowModalSuccess(false)} type='button'>Close</button>
                </div>
            </div>
        </div>
    </section>
    return (
        <>
            {showModal && __renderPOView()}
            {showModalSuccess && __renderPOViewSuccess()}
            <div className="container">
                <div className="container-top">
                    <div className="logo">
                        <img src="/parasite_name_logo.png" alt="wallet.image" />
                    </div>
                </div>
                <div className="container-body">
                    <div className="sidebar">
                        <div className="welcome">
                            <h3>Welcome to Parasite</h3>
                            {(!paymentAddressItemDisplay) && (
                                <button className="btn" onClick={connectWallet} type='button'>Connect Xverse Wallet</button>
                            )}
                            {!!paymentAddressItemDisplay && (
                                <div className="welcome-address">
                                    <span>{paymentAddressItemDisplay}</span>
                                </div>
                            )}
                        </div>
                        <nav className="nav">
                            <button className="nav-item" type='button'>
                                <img src="/parasite_insect_logo.png" alt="wallet.image" />
                                <span style={{ paddingLeft: '6px' }}>Lightning</span>
                            </button>
                        </nav>
                        <nav className="nav-end">
                            <button className="nav-item-logout" onClick={logout} type='button'>
                                <span>Logout</span>
                            </button>
                        </nav>
                    </div>
                    <main className="main-content">

                        <div className="card">
                            <div className='card-top'>
                                <h1>Explore</h1>
                                <p className='card-top-subtitle'>Your Lightning Wallet</p>
                                {balance_username && (
                                    <p className='card-top-balance'>{balance_username}@sati.pro</p>
                                )}
                            </div>

                            {card_status === card_status_connect && (
                                <div className="card-inner">
                                    <h3>Connect to your Parasite portal
                                    </h3>
                                    {/* <p>Connect your Parasite wallet to use Lightning functionality</p> */}
                                    <button className="btn" onClick={connectWallet} type='button'>Connect Xverse Wallet</button>
                                </div>
                            )}
                            {card_status === card_status_sign && (
                                <div className="card-inner">
                                    <h3>Sign message with Parasite</h3>
                                    <p>Sign a message with your Parasite wallet to initialize your Lightning wallet</p>
                                    <button className="btn" type='button'>Sign Message</button>
                                </div>
                            )}
                            {card_status === card_status_mail && (
                                <div className="card-inner">
                                    <p>Enter your mail</p>
                                    <input
                                        type="text"
                                        value={valueMail}
                                        onChange={(e) => handleInputMailChange(e, setValueMail)}
                                        className={!inputError ? "mail-input" : "mail-input error"}
                                    />
                                    <button className="btn submit" onClick={submit} type='button'>Submit</button>
                                </div>
                            )}
                            {card_status === card_status_balance && (
                                <div className="card-inner">
                                    <div className='card-balance'>
                                        <p className='title'>Balance</p>
                                        <p className='sats'>{formatNumberWithCommas(balance)} sats</p>
                                    </div>
                                    <button type='button' className={(balance < min_balance_to_w) ? 'btn disabled' : 'btn'} onClick={withdraw} disabled={balance < min_balance_to_w}>Withdraw</button>
                                    <p className='min-sats'>Minimum balance to withdraw {formatNumberWithCommas(min_balance_to_w)} sats</p>
                                </div>
                            )}
                        </div>
                        <div className='footer'>Powered by <a href="https://x.com/heySati" target="_blank" rel="noopener noreferrer" style={{ marginRight: '2px' }}> <img src="/icon-512.png" alt="sati-logo" /> Sati</a> and <a href="https://www.xverse.app/download" target="_blank" rel="noopener noreferrer"> <img src="/xverse-logo.png" alt="xverse-logo" /> Xverse</a> </div>
                        <nav className="mobile-logout">
                            <button type='button' className="nav-item-logout" onClick={logout}>
                                <span>Logout</span>
                            </button>
                        </nav>
                    </main>
                </div >
            </div>
        </>
    );
}

export default Main;
